import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ROUTES } from '@utils/constants';
import { PillButtonDTO } from '@app/infrastructure/models/pill-button-dto';
import { ITeacherClassDetailDTO } from '@app/infrastructure/models/teacher-classroom';

@Component({
  selector: 'app-pill-button',
  templateUrl: './pill-button.component.html',
  styleUrls: ['./pill-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillButtonComponent {
  @Input() pillButtonDTO: PillButtonDTO;
  @Input() gradingLink: string;
  @Input() hasEdit: boolean;
  @Input() public classroom: ITeacherClassDetailDTO;
  @Output() selectedChanged = new EventEmitter<PillButtonDTO>();
  @Output() editClicked = new EventEmitter<void>();

  onSelectedChanged(): void {
    this.selectedChanged.emit(this.pillButtonDTO);
  }

  onEditClick(): void {
    this.editClicked.emit();
  }
}
